module.exports = __webpack_public_path__ + "static/media/cliente-agropar.b82dcc1a.webp";